"use client";

import { useState } from "react";
import Logo from "./Logo";
import TextField from "./TextField";
import Button from "./Button";
import { AccountView } from "@/lib/types";

/** ログイン画面 */
export default function LoginScreen({
  onLoggedIn,
  onCreateAccount,
}: {
  onLoggedIn: (account: AccountView) => void;
  onCreateAccount: () => void;
}) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit() {
    setBusy(true);
    setMessage("");
    try {
      const response = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const body = await response.json();
      if (!response.ok) {
        setMessage(body.error ?? "ログインに失敗しました");
        return;
      }
      onLoggedIn(body.account as AccountView);
    } catch {
      setMessage("サーバーに繋がりません");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="panel panel-scene panel-login">
      <Logo />
      <form
        onSubmit={(event) => {
          event.preventDefault();
          submit();
        }}
      >
        <TextField
          id="login-username"
          label="ユーザー名"
          value={username}
          onChange={setUsername}
          autoComplete="username"
          disabled={busy}
        />
        <TextField
          id="login-password"
          label="パスワード"
          type="password"
          value={password}
          onChange={setPassword}
          autoComplete="current-password"
          disabled={busy}
        />

        <div className="actions">
          <Button type="submit" variant="primary" disabled={busy}>
            ログイン
          </Button>
          <Button onClick={onCreateAccount} disabled={busy}>
            アカウント作成
          </Button>
        </div>
      </form>

      <p className="message">{message}</p>
    </div>
  );
}
